'use client'
import React from 'react';
import { Link } from 'react-router-dom'; // Use react-router-dom for routing.
import { useState } from 'react';

const SureMain = () => {
    // State to hold dynamic content
  
    return (
        <React.Fragment>
<div style={{ height: '300px' }}></div> 
            {/* Service Details Start */}
            {/* Service Details End */}
        </React.Fragment>
    );
};

export default SureMain;
